// LandUsesForm.jsx
import { Button, Grid, Box } from '@mui/material'
import InputForm from '../SwmmReact_Staging/InputForm'
import "../../css/DemoCode.css"

/**
 * Land Uses Form is a group of data inputs usually shown when clicking on Quality->Land Uses. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {function} setFullModel Sets the full model in case of any updates.
 * @param {string} targetType The name of the layer targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function LandUsesForm({ model, setModel, fullModel, setFullModel, targetType, target }) {
  
  const saveEdits = () => {
    setFullModel(prev => ({
      ...prev, 
      LANDUSES: {
        ...prev.LANDUSES, 
        [target]: model.LANDUSES[target]
      }
    }))
  }

  return(
    <>
    {
      <>
      <Grid container>
        <Grid item xs={12}>
        {
          <Grid container spacing={2} padding={2}>
            <Box sx={{width: '100%' }}>
              <div>
                <Button fullWidth onClick={saveEdits} >Save Edits</Button>
              </div>
                {
                  targetType && 
                  targetType in model && 
                  target &&
                  target in model[targetType] &&
                  <>
                  <div className="infocol">
                    <InputForm model={model} setModel={setModel} fullModel={fullModel} targetType={targetType} target={target} />
                  </div>
                  </>
                }
            </Box>
          </Grid>
        }
        </Grid>
      </Grid>
      </>
        }
    </>
  )
} 